import {
    ADDITIONAL_PACKAGES,
    BACK,
    CHANGE,
    CHANGE_TARIFF,
    CHANGE_TARIFF_WARNING,
    CHANNELS,
    CHANNELS_LIST,
    CHOOSE,
    CHOOSE_CITY,
    CHOOSE_FREE_PACKAGE_1,
    CHOOSE_FREE_PACKAGE_2,
    CHOOSE_FREE_PACKAGE_3,
    CHOOSE_MUNICIPALITY,
    CHOOSE_TARIFF_MODEL,
    CHOSEN,
    CHOSEN_ADDITIONAL_PACKAGES,
    CHOSEN_FREE_PACKAGES,
    CHOSEN_TARIFF_MODEL,
    INCLUDED_CHANNELS_IN_PACKAGE_1,
    INCLUDED_CHANNELS_IN_PACKAGE_2,
    INCLUDED_CHANNELS_IN_TARIFF,
    INCLUDED_PACKAGES,
    INCLUDED_REGIONAL_CHANNELS,
    MKD,
    MKD_MONTHLY,
    ORDER,
    TARIFF_MODEL,
    TARIFF_TYPE,
    TOTAL_SUBSCRIPTION,
    CHOOSE_CITY_MUNICIPALITY_TARIFF,
    CHOOSE_TARIFF,
    CHOOSE_FREE_PACKAGE_1_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW_FREE,
    CHOOSE_FREE_PACKAGE_3_NEW,
    CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM,
    PRICE_INCLUDE_VAT,
    DVBT_OFFER_CHANNELS, TV_CHANNELS, AVAILABLE
} from "./keys";

export const enContent = [
    {
        key: CHOOSE_TARIFF_MODEL,
        value: 'Please select one of the tariff plans offered'
    },
    {
        key: TARIFF_MODEL,
        value: 'Tariff plan'
    },
    {
        key: TARIFF_TYPE,
        value: 'Tariff type'
    },
    {
        key: CHANNELS,
        value: 'Channels'
    },
    {
        key: CHANNELS_LIST,
        value: 'TV channel list'
    },
    {
        key: INCLUDED_PACKAGES,
        value: 'TV channels included'
    },
    {
        key: CHOOSE_FREE_PACKAGE_1,
        value: 'CHOOSE'
    },
    {
        key: CHOOSE_FREE_PACKAGE_2,
        value: ' FROM THE BUNDLES BELOW'
    },
    {
        key: CHOOSE_FREE_PACKAGE_3,
        value: 'that can be included in the plan of your choice, completely free of charge.'
    },
    {
        key: ADDITIONAL_PACKAGES,
        value: 'Additional bundles'
    },
    {
        key: CHOSEN_TARIFF_MODEL,
        value: 'Tariff plan selected'
    },
    {
        key: CHOSEN_FREE_PACKAGES,
        value: 'Free bundles selected'
    },
    {
        key: CHOSEN_ADDITIONAL_PACKAGES,
        value: 'Additional bundles selected'
    },
    {
        key: TOTAL_SUBSCRIPTION,
        value: 'Total monthly fee'
    },
    {
        key: ORDER,
        value: 'Order'
    },
    {
        key: MKD_MONTHLY,
        value: 'MKD/monthly'
    },
    {
        key: MKD,
        value: 'MKD'
    },
    {
        key: CHOOSE,
        value: 'Select'
    },
    {
        key: CHOSEN,
        value: 'Selected'
    },
    {
        key: INCLUDED_CHANNELS_IN_PACKAGE_1,
        value: 'Included channels in the '
    },
    {
        key: INCLUDED_CHANNELS_IN_PACKAGE_2,
        value: ' bundle'
    },
    {
        key: CHANGE_TARIFF,
        value: 'Tariff plan change'
    },
    {
        key: CHANGE_TARIFF_WARNING,
        value: 'Please note that if you decide to switch to another tariff plan, the selected bundles will be written over. Are you sure you want to change the tariff plan?'
    },
    {
        key: CHANGE,
        value: 'Change'
    },
    {
        key: BACK,
        value: 'Back'
    },
    {
        key: CHOOSE_CITY,
        value: 'Please select city'
    },
    {
        key: CHOOSE_MUNICIPALITY,
        value: 'Please select municipality'
    },
    {
        key: INCLUDED_REGIONAL_CHANNELS,
        value: 'Regional TV channels are included free of charge in the tariff plan of your choice and the number of TV channels depends on the availability in the region of TV service.'
    },
    {
        key:INCLUDED_CHANNELS_IN_TARIFF,
        value: 'TV channels included in the selected tariff plan'
    },
    {
        key: CHOOSE_CITY_MUNICIPALITY_TARIFF,
        value: 'To see the included TV channels, please select city, municipality and tariff plan'
    },
    {
        key: CHOOSE_TARIFF,
        value: 'Choose a tariff'
    },
    {
        key:CHOOSE_FREE_PACKAGE_1_NEW,
        value: 'With the selected tariff plan, you will get'
    },
    {
        key:CHOOSE_FREE_PACKAGE_2_NEW,
        value: ' of the following TV bundles '
    },
    {
        key:CHOOSE_FREE_PACKAGE_2_NEW_FREE,
        value: 'free of charge.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW,
        value: 'The remaining TV bundles may be activated at the listed monthly fees.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE,
        value: 'The HBO Premium Lite bundle is available at monthly fee solely.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM,
        value: 'The HBO Premium bundle is available at monthly fee solely.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES,
        value: 'TV bundles available for activation at the listed monthly fees.'
    },
    {
        key:PRICE_INCLUDE_VAT,
        value: 'All stated prices include VAT.'
    },
    {
        key:DVBT_OFFER_CHANNELS,
        value: 'The offer featuring the listed number of TV channels is available with optical or cable technology. If there are no technical conditions for these technologies at your specific location, we will offer you DVBT technology featuring the following '
    },
    {
        key: TV_CHANNELS,
        value: 'TV channels'
    },
    {
        key: AVAILABLE,
        value: 'available.'
    }
];
